import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { SuccessIcon, RemoveIcon } from 'foundations-assets';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import TwoFactorTokenExpired from './TwoFactorTokenExpired';
import { useDispatch, useSelector } from 'react-redux';
import { getIsRecovering, getRecoveryAttempted, getRecoverySent, getIsRecoveryEmailToSupportInErrorState, getRecoveryNeedsSupport, getRecoveryExpired
// @ts-expect-error not converted to TS yet
} from 'LoginUI/selectors/TwoFactorRecovery';
import { getEmail, getToken } from 'LoginUI/selectors/TwoFactorAuth';
import { sendTwoFactorRecoveryEmail } from '../../actions/twoFactorRecovery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoFactorRecoverySupportForm = () => {
  const email = useSelector(getEmail) || 'your email';
  const isRecovering = useSelector(getIsRecovering);
  const recoveryAttempted = useSelector(getRecoveryAttempted);
  const recoverySent = useSelector(getRecoverySent);
  const isRecoveryEmailInErrorState = useSelector(getIsRecoveryEmailToSupportInErrorState);
  const recoveryNeedsSupport = useSelector(getRecoveryNeedsSupport);
  const recoveryExpired = useSelector(getRecoveryExpired);
  const token = useSelector(getToken) || '';
  const dispatch = useDispatch();
  const handleSubmit = event => {
    event.preventDefault();
    void dispatch(sendTwoFactorRecoveryEmail(token));
  };
  const renderRecoveryButton = () => {
    return /*#__PURE__*/_jsx(LoadingButton, {
      block: true,
      use: "primary",
      type: "submit",
      disabled: !isRecovering && recoveryAttempted,
      resultIcon: !recoveryAttempted || recoverySent ? SuccessIcon : RemoveIcon,
      onClick: handleSubmit,
      loading: isRecovering,
      children: I18n.text('login.twoFactor.recoverySupport.form.recoverButton')
    });
  };
  const renderAlerts = () => {
    if (isRecoveryEmailInErrorState) {
      if (recoveryNeedsSupport) {
        return /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: I18n.text('login.twoFactor.recovery.error.needsSupport')
        });
      }
      return /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: I18n.text('login.twoFactor.recovery.error.errorText')
      });
    }
    return null;
  };
  const renderForm = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.twoFactor.recoverySupport.form.description"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.twoFactor.recoverySupport.form.descriptionMore",
          options: {
            email
          }
        })
      }), renderAlerts(), renderRecoveryButton()]
    });
  };
  const renderSuccess = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.twoFactor.recoverySupport.success.emailed",
          options: {
            email
          }
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.twoFactor.recoverySupport.success.questions"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.twoFactor.recoverySupport.success.submitted"
        })
      })]
    });
  };
  let content;
  if (recoveryAttempted && recoveryExpired) {
    content = /*#__PURE__*/_jsx(TwoFactorTokenExpired, {});
  } else if (!recoveryAttempted || !recoverySent) {
    content = renderForm();
  } else {
    content = renderSuccess();
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        as: "h1",
        children: I18n.text('login.twoFactor.recoverySupport.header')
      }), content]
    })
  });
};
export default TwoFactorRecoverySupportForm;